import { Separator as SeparatorPrimitive } from '@base-ui/react/separator';
import { cn } from '@sohanemon/utils';

function Separator({
	className,
	orientation = 'horizontal',
	...props
}: SeparatorPrimitive.Props) {
	return (
		<SeparatorPrimitive
			data-slot="separator"
			orientation={orientation}
			data-horizontal={orientation === 'horizontal' ? '' : undefined}
			data-vertical={orientation === 'vertical' ? '' : undefined}
			className={cn(
				'shrink-0 bg-border data-horizontal:h-px data-horizontal:w-full data-vertical:w-px data-vertical:self-stretch',
				className,
			)}
			{...props}
		/>
	);
}

export { Separator };
